import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from '../../../../utilities/helperFunctions';
import { messageTypes } from '../../../Includes/variables';

import { getFormattedTimestamp } from '../../../Utilities/TimeFunctions';
import DefaultIntroMessage from '../../DefaultIntroMessage/DefaultIntroMessage';
import MessageBlock from '../../MessageBlock/MessageBlock';

export default class MessageItem extends React.PureComponent {
    static propTypes = {
        message: PropTypes.object.isRequired,
        /**
         * function passed in to check if user is the current logged in user
         */
        isLoggedInUser: PropTypes.func,
        /**
         * get user meta info with user id
         */
        getUsersInfoById: PropTypes.func,
        /**
         * type of message channel
         */
        messageType: PropTypes.oneOf(Object.values(messageTypes)),
        /**
         * allow hover over
         */
        enableHoverOver: PropTypes.bool,
        /**
         * professionalUsername from channelData, if this is a recruiter chat
         */
        candidateUserName: PropTypes.string,
    };

    static defaultProps = {
        message: {},
        isLoggedInUser: () => {},
        getUsersInfoById: () => {},
        messageType: messageTypes.COMMUNITY,
        enableHoverOver: true,
        candidateUserName: null,
    };

    render() {
        const {
            message,
            isLoggedInUser,
            getUsersInfoById,
            messageType,
            enableHoverOver,
            index,
            isRecruiterChatCandidate,
            pageDisplayMode,
            candidateUserName,
        } = this.props;

        if (isEmpty(message) || message.type === 'deleted') return null;

        const {
            id: messageId,
            text,
            user,
            welcomeMessage,
            updated_at: updatedAt,
            type,
        } = message;
        const { id, credential, logo, username } = user;
        const userDisplayName = isLoggedInUser(id) ? 'You' : username;
        const timestamp = getFormattedTimestamp(updatedAt);

        if (welcomeMessage) {
            return (
                <MessageBlock
                    key={`megan-welcome-${index}`}
                    username="Megan Smolen"
                    userTitle="Director of Community at Fairygodboss"
                    timeStamp={timestamp}
                    messageContent={<DefaultIntroMessage />}
                    src="/v1/user/profile/mbdo0ww7l0s0d8rbch6y"
                    user={getUsersInfoById(id)}
                    messageId={messageId}
                    authorId={user.id}
                    enableHoverOver={enableHoverOver}
                    messageType={messageType}
                    isLoggedInUser={isLoggedInUser}
                    isRecruiterChatCandidate={isRecruiterChatCandidate}
                    candidateUserName={candidateUserName}
                    pageDisplayMode={pageDisplayMode}
                />
            );
        }

        return (
            <MessageBlock
                key={`${messageId}-${index}`}
                username={userDisplayName}
                userTitle={credential}
                timeStamp={timestamp}
                messageContent={text}
                src={logo}
                user={getUsersInfoById(id)}
                messageId={messageId}
                authorId={user.id}
                type={type}
                enableHoverOver={enableHoverOver}
                messageType={messageType}
                isLoggedInUser={isLoggedInUser}
                isRecruiterChatCandidate={isRecruiterChatCandidate}
                candidateUserName={candidateUserName}
                pageDisplayMode={pageDisplayMode}
            />
        );
    }
}
